import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_date_editor = _resolveComponent("inline-date-editor")!

  return (_openBlock(), _createBlock(_component_inline_date_editor, {
    ref: "editorRef",
    id: _ctx.editorId,
    modelValue: _ctx.theModel,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.theModel) = $event)),
    editable: _ctx.editable,
    compact: _ctx.isTable,
    "move-to-body": true,
    onCommit: _ctx.onCommit
  }, null, 8, ["id", "modelValue", "editable", "compact", "onCommit"]))
}